import { Heading } from "./heading";
import { Item } from "./item";
import IconBenefit1 from "./svg/benefit-1.svg";
import IconBenefit2 from "./svg/benefit-2.svg";
import IconBenefit3 from "./svg/benefit-3.svg";

export const Benefits = () => {
  return (
    <div
      css={`
        margin: 0 0 96px 0;
        padding: 36px 20px;
        background: white;

        @media (min-width: 960px) {
          padding: 90px 20px;
        }
      `}
    >
      <div
        css={`
          margin: 0 auto;
          max-width: 1220px;
          display: flex;
          flex-direction: column;
          gap: 51px;

          @media (min-width: 960px) {
            gap: 66px;
          }
        `}
      >
        <Heading />
        <Items />
      </div>
    </div>
  );
};

const Items = () => {
  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        gap: 60px;

        @media (min-width: 960px) {
          padding: 0 100px;
          flex-direction: row;
          gap: 74px;
        }
      `}
    >
      <Item
        icon={<IconBenefit3 />}
        color="#E0F2FE"
        title="Lawfully Intelligence & Data-Driven Decisions"
      />
      <Item
        icon={<IconBenefit1 />}
        color="#FFF6D7"
        title="Real-time USCIS, NVC, DOL, and EOIR update"
      />
      <Item
        icon={<IconBenefit2 />}
        color="#F3E8FF"
        title="Automated Notification & Custom Web Portal"
      />
    </div>
  );
};
